var _jsxFileName = "/codebuild/output/src4058294914/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/CheckYourEmail/index.tsx";
import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { InformationalScreen, Stack } from '@adc/parallax-component-library';
import { ApiStatus, ErrorCode } from 'Constants';
import { useApiError, useAuth, useClickContinueEmailVerificationButton, useResendVerificationEmail } from 'Hooks';
import { Footer, MainContainer, TopHeaderBackArrow } from 'Components/utility';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { signIn } from 'Services/auth';
import CheckYourEmailComponents from './components';
const mapStateToProps = ({
  auth: {
    account_id
  },
  env: {
    deviceId,
    installationId,
    osType,
    osVersion,
    app,
    appVersion,
    appHash
  }
}) => {
  return {
    account_id,
    deviceId,
    installationId,
    osType,
    osVersion,
    app,
    appVersion,
    appHash
  };
};
const connector = connect(mapStateToProps);
const CheckYourEmail = ({
  data: {
    password,
    email
  },
  deviceId,
  installationId,
  osType,
  osVersion,
  app,
  appVersion,
  appHash,
  account_id
}) => {
  const {
    showApiErrorModal,
    showNetworkErrorModal
  } = useApiError();
  const {
    showCountryRegionError
  } = useAuth();
  useEffect(() => {
    if (!password || !email) {
      mediator.publish('router:navigate', '/login');
    }
  }, [email, password]);
  const handleGoBack = () => {
    mediator.publish('router:back');
  };
  const handleApiRequestError = useCallback(error => {
    switch (error.status) {
      case ApiStatus.BAD_REQUEST:
        {
          var _error$response;
          const code = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.code;
          if (code === ApiStatus.UNSUPPORTED_COUNTRY || code === ApiStatus.WRONG_REGION) {
            showCountryRegionError();
            return;
          }
          break;
        }
      case ApiStatus.UNAUTHORIZED:
        {
          var _error$response2;
          const code = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.code;
          if (code === ApiStatus.EXPIRED_AUTH_TOKEN) {
            mediator.publish('router:navigate', '/login');
          }
          showApiErrorModal();
          break;
        }
      default:
        error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
    }
  }, [showApiErrorModal, showCountryRegionError, showNetworkErrorModal]);
  const signInFunction = useCallback(async () => {
    const authSession = await signIn({
      email,
      password: password.trim(),
      osType,
      osVersion,
      app,
      appVersion,
      deviceId,
      installationId,
      appHash
    });
    notifyApp('adc-webview:signin', authSession);
  }, [email, password, osType, osVersion, app, appVersion, deviceId, installationId, appHash]);
  const {
    handleResendEmailButtonClick
  } = useResendVerificationEmail({
    account_id,
    osType,
    osVersion,
    app,
    appVersion,
    handleApiRequestError
  });
  const {
    handleContinueEmailVerificationButtonClick
  } = useClickContinueEmailVerificationButton({
    account_id,
    osType,
    osVersion,
    app,
    appVersion,
    installationId,
    handleApiRequestError,
    signInFunction
  });
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      title: i18n.t('CheckYourEmailRegistration.title'),
      animatedTitle: true,
      buttonStart: {
        element: /*#__PURE__*/React.createElement(TopHeaderBackArrow, {
          testID: "Auth.action-go-back",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 143,
            columnNumber: 22
          }
        }),
        onPress: handleGoBack
      }
    },
    testID: "CheckYourEmail",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    marginTop: -8,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(CheckYourEmailComponents.Content, {
    email: email,
    onButtonPress: handleResendEmailButtonClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    buttonLabel: i18n.t('Global.microcopy.common.continue'),
    onButtonPress: handleContinueEmailVerificationButtonClick,
    buttonTestID: "CheckYourEmailRegistration.continueButton",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 13
    }
  })))));
};
export default connector(CheckYourEmail);